import SystemErrorMessage from './container/SystemErrorMessage';

export default SystemErrorMessage;



// WEBPACK FOOTER //
// ./src/views/SystemErrorMessage/index.js